import type { ReactNode } from 'react';
import { Box, Button, Card, Chip, CardContent, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

type Props = {
  title: string;
  subtitle?: ReactNode;
  viewAll?: string;
  /** a small number badge beside the title */ count?: number;
  children?: ReactNode;
};

/** The white box every section of a page sits in. `viewAll` adds a "View all →" link to that page. */
export function Panel({ title, subtitle, viewAll, count, children }: Props) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack spacing={1.5}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <Box>
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <Typography variant="h6">{title}</Typography>
                {count !== undefined && <Chip size="small" label={count} />}
              </Stack>
              {subtitle && (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
            </Box>
            {viewAll && (
              <Button
                component={RouterLink}
                to={viewAll}
                size="small"
                endIcon={<ArrowForwardIcon />}
                sx={{ flexShrink: 0 }}
              >
                View all
              </Button>
            )}
          </Stack>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
}
